// extracted by mini-css-extract-plugin
export default {"createDeposit":"ContainerButtons_createDeposit__DnP3j","depositCredits":"ContainerButtons_depositCredits__th2VB"};